 
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TokenResponse, CurrentUserInfoResponse as CurrentUserInfo } from '@uptime-bff/api-contract';
import storage from 'redux-persist/es/storage';

export const defaultState: AuthState = {
  isAuthenticated: false,
  isLoggingOut: false,
  currentUserInfo: undefined,
  isOpenSalesCompanyCodesGuide: false,
};

interface AuthState {
  isAuthenticated: boolean;
  isLoggingOut: boolean;
  oidcNonce?: string;
  oidcState?: string;
  user?: TokenResponse;
  currentUserInfo?: CurrentUserInfo;
  isOpenSalesCompanyCodesGuide: boolean;
}

const slice = createSlice({
  name: 'auth',
  initialState: defaultState,
  reducers: {
    login: (state, action: PayloadAction<TokenResponse>) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    logout: (state) => {
      storage.removeItem('persist:root');
      state.isLoggingOut = true;
      state.isAuthenticated = false;
      state.user = undefined;
      state.oidcNonce = undefined;
      state.oidcState = undefined;
    },
    setLoggedOut: (state) => {
      state.isLoggingOut = false;
    },
    setOidcNonce: (state, action: PayloadAction<string>) => {
      state.oidcNonce = action.payload;
    },
    setOidcState: (state, action: PayloadAction<string>) => {
      state.oidcState = action.payload;
    },
    setUserCurrentInfo(state, action: PayloadAction<CurrentUserInfo | undefined>) {
      state.currentUserInfo = action.payload;
    },
    setIsOpenSalesCompanyCodesGuide(state, action: PayloadAction<boolean>) {
      state.isOpenSalesCompanyCodesGuide = action.payload;
    },
  },
});

export const {
  login,
  setOidcNonce,
  setOidcState,
  logout,
  setLoggedOut,
  setUserCurrentInfo,
  setIsOpenSalesCompanyCodesGuide,
} = slice.actions;
export default slice.reducer;
